var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticStyle: { height: "90vh" } }, [
    _c(
      "div",
      { staticClass: "my-5 ml-3" },
      [
        _c("b-button", {
          attrs: { "icon-left": "arrow-left" },
          on: { click: _vm.close },
        }),
        _c(
          "ul",
          { staticClass: "point-list my-5" },
          _vm._l(_vm.groupedPointsBySi, function (collapse, index) {
            return _c(
              "b-collapse",
              {
                key: collapse[0].si,
                staticClass: "card",
                attrs: { animation: "slide", open: _vm.isOpen === index },
                on: {
                  open: function ($event) {
                    _vm.isOpen = index
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "trigger",
                      fn: function (props) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "card-header",
                              attrs: {
                                role: "button",
                                "aria-controls": "contentIdForA11y5-" + index,
                                "aria-expanded": props.open,
                              },
                            },
                            [
                              _c("p", { staticClass: "card-header-title" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(collapse[0].si) +
                                    " - " +
                                    _vm._s(collapse[0].customerName) +
                                    " "
                                ),
                              ]),
                              _c(
                                "a",
                                { staticClass: "card-header-icon" },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: props.open
                                        ? "caret-down"
                                        : "caret-up",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              },
              [
                _c("div", { staticClass: "card-content" }, [
                  _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _vm._l(collapse.slice(0, -1), function (p, i) {
                        return _c("li", { key: i }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "is-flex is-flex-direction-row is-align-items-stretch",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "is-flex is-flex-direction-column is-justify-content-space-between is-size-7 mr-2",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "mt-2" },
                                    [
                                      _c(
                                        "b-tooltip",
                                        {
                                          attrs: {
                                            label: `${new Date(
                                              p.timestamp
                                            ).toLocaleString()}`,
                                            position: "is-right",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$dayjs(p.timestamp)
                                                  .local()
                                                  .format("MM/DD")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      p.endTimestamp
                                        ? _c(
                                            "div",
                                            { staticClass: "mt-1" },
                                            [
                                              _c(
                                                "b-tooltip",
                                                {
                                                  attrs: {
                                                    label: `${new Date(
                                                      p.endTimestamp
                                                    ).toLocaleString()}`,
                                                    position: "is-right",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm
                                                          .$dayjs(
                                                            p.endTimestamp
                                                          )
                                                          .local()
                                                          .format("MM/DD")
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "mb-5" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.panelPoints[i + 1] &&
                                            _vm.panelPoints[i + 1].duration
                                            ? `${
                                                _vm.panelPoints[i + 1].duration
                                              }d`
                                            : null
                                        ) +
                                        " " +
                                        _vm._s(
                                          i === _vm.panelPoints.length - 1
                                            ? `${_vm.calDuration(
                                                p.endTimestamp || p.timestamp,
                                                Date.now()
                                              )}d`
                                            : null
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "is-flex is-flex-direction-column is-align-items-center",
                                },
                                [
                                  _c("b-button", {
                                    style: {
                                      width: "50px",
                                      height: "50px",
                                      borderRadius: "50%",
                                      backgroundColor: _vm.getIconColor(p),
                                      color: "white",
                                    },
                                    attrs: { "icon-left": _vm.getIcon(p) },
                                    on: {
                                      click: function ($event) {
                                        return _vm.focusOnPoint(p)
                                      },
                                    },
                                  }),
                                  i !== _vm.panelPoints.length - 1
                                    ? _c("div", { staticClass: "solid-line" })
                                    : _c("div", {
                                        class: `${_vm.lastStatus.lineType}-line`,
                                      }),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "ml-5" }, [
                                _c("p", [
                                  _c("strong", [
                                    _vm._v(" " + _vm._s(p.status) + " "),
                                  ]),
                                ]),
                                _c("p", { staticClass: "is-size-6" }, [
                                  _vm._v(
                                    " " + _vm._s(p.name || "Unknown name") + " "
                                  ),
                                ]),
                                _c("p", [
                                  _vm._v(
                                    " " + _vm._s(p.country || "Unknown") + " "
                                  ),
                                ]),
                                _c("br"),
                              ]),
                            ]
                          ),
                        ])
                      }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "is-flex is-flex-direction-row is-align-items-center",
                        },
                        [
                          _c(
                            "button",
                            {
                              style: {
                                width: "50px",
                                height: "50px",
                                borderRadius: "50%",
                                border: "1px dotted #D3D3D3",
                                backgroundColor:
                                  collapse[collapse.length - 1].status ===
                                  "Finished"
                                    ? "#6abf9e"
                                    : "transparent",
                              },
                              attrs: { "icon-left": "check" },
                            },
                            [
                              _c("b-icon", {
                                style: {
                                  color:
                                    collapse[collapse.length - 1].status ===
                                    "Finished"
                                      ? "white"
                                      : "#D3D3D3",
                                },
                                attrs: {
                                  icon:
                                    collapse[collapse.length - 1].status ===
                                    "Finished"
                                      ? "check"
                                      : "truck",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "ml-5",
                              style: {
                                color:
                                  collapse[collapse.length - 1].status ===
                                  "Finished"
                                    ? "black"
                                    : "#D3D3D3",
                                fontWeight: "700",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(collapse[collapse.length - 1].status) +
                                  " "
                              ),
                            ]
                          ),
                          _c("br"),
                        ]
                      ),
                    ],
                    2
                  ),
                ]),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }